import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginGuard } from '../auth/loginGuard';
import { EmployerLayoutComponent } from './employer-layout/employer-layout.component';
import { EmployerDashboardComponent } from './employer-dashboard/employer-dashboard.component';
import { EmployeesComponent } from './employees/employees.component';
import { EmployerAdminToolComponent } from './employer-admin-tool/employer-admin-tool.component';
import { EmployersComponent } from './employers/employers.component';
import { EmployerPaymentMethodComponent } from './employer-payment-method/employer-payment-method.component';
import { EmployerPaymentHistoryComponent } from './employer-payment-history/employer-payment-history.component';
import { EmployerProfileComponent } from './employer-profile/employer-profile.component';
import { EmployerFindCareComponent } from './employer-find-care/employer-find-care.component';
import { PlanCoverageComponent } from './plan-coverage/plan-coverage.component';
import { EmployerSubscriptionsComponent } from './employer-subscriptions/employer-subscriptions.component';
import { EmployerCheckoutComponent } from './employer-checkout/employer-checkout.component';
import { FindCareComponent } from '../shared/components/find-care/find-care.component';
import { FindCareTeamComponent } from '../shared/components/find-care/find-care-team/find-care-team.component';
import { EmployerPlanDetailsComponent } from './employer-plan-details/employer-plan-details.component';
import { CompanyProfileComponent } from './company-profile/company-profile.component';
import { AddEmployeeCheckoutComponent } from './add-employee-checkout/add-employee-checkout.component';
import { SelectedMultiplePlanComponent } from './selected-multiple-plan/selected-multiple-plan.component';
import { EmployeeActiveProgramCheckoutComponent } from './employee-active-program-checkout/employee-active-program-checkout.component';
import { EmployerChoosePlansComponent } from './employer-choose-plans/employer-choose-plans.component';
import { EmployerActivePlansComponent } from './employer-active-plans/employer-active-plans.component';
import { MyEmployeesSubscriptionComponent } from './my-employees-subscription/my-employees-subscription.component';
import { EmployerSettingsComponent } from './employer-settings/employer-settings.component';
const routes: Routes = [
  {
    path: 'employer',
    component: EmployerLayoutComponent,
    children: [
      { path: '', redirectTo: "/employer/dashboard", pathMatch: "full" },
      {
        path: 'dashboard',
        component: EmployerDashboardComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'employees',
        component: EmployeesComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'planCoverages',
        component: PlanCoverageComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'findCare',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'findCare/:categoryId',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'team/findCare',
        component: FindCareTeamComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'communications',
        component: EmployerDashboardComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'profile',
        component: EmployerProfileComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'payment-method',
        component: EmployerPaymentMethodComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'payment-history',
        component: EmployerPaymentHistoryComponent,
        canActivate: [LoginGuard],
      },
      // {
      //   path: 'subscription-method',
      //   component: EmployerSubscriptionsComponent,
      //   canActivate: [LoginGuard],
      // },
      {
        path: 'setupCheckout/:id',
        component: EmployerCheckoutComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'addempCheckout',
        component: AddEmployeeCheckoutComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'empPlanDetails',
        component: EmployerPlanDetailsComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'company-profile',
        component: CompanyProfileComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'selectPlan',
        component: SelectedMultiplePlanComponent,
        canActivate: [LoginGuard],
      },
      
      {
        path: 'activeProgram',
        component: EmployeeActiveProgramCheckoutComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'subscription',
        component: EmployerChoosePlansComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'mysubscription',
        component: EmployerActivePlansComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'myemployees',
        component: MyEmployeesSubscriptionComponent,
        canActivate: [LoginGuard],
      },
      
      {
        path: 'settings',
        component: EmployerSettingsComponent,
        canActivate: [LoginGuard],
      },
    ]
  }];

@NgModule({
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployerRoutingModule { }
